<script setup>
import { ref, onMounted, onBeforeUnmount, watch } from 'vue'
import { useRouter } from 'vue-router'
import { initializeApp } from "firebase/app"
import { usePerfilStore } from '@/stores/settings/perfilStore' // ⬅️ importar store
import { useUserStore } from '@/stores/userStore'
import { useNotificationStore } from '@/stores/notifications/useNotificationStore'

const isOnline = ref(true)
const isDark = ref(false)
const router = useRouter()
const userStore = useUserStore()
const notificationStore = useNotificationStore()

const updateOnlineStatus = () => {
  isOnline.value = navigator.onLine
  if (!isOnline.value) {
    router.push({ name: 'Offline' })
  }
}

const firebaseConfig = {
  apiKey: "AIzaSyCoqlyEpTZcZuDEddDZwto0_PHrsSpICws",
  authDomain: "testedashboard-dd576.firebaseapp.com",
  projectId: "testedashboard-dd576",
  storageBucket: "testedashboard-dd576.firebasestorage.app",
  messagingSenderId: "982498656380",
  appId: "1:982498656380:web:b9996dddddfe07bed189f9",
  measurementId: "G-T0TR2BTFL9"
}

onMounted(() => {
  // Dark mode
  const storedDarkMode = localStorage.getItem('darkMode')
  if (storedDarkMode === null) {
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    isDark.value = prefersDark
    localStorage.setItem('darkMode', prefersDark)
  } else {
    isDark.value = storedDarkMode === 'true'
  }
  document.documentElement.classList.toggle('dark', isDark.value)

  // Firebase
  initializeApp(firebaseConfig)

  // Conexão
  window.addEventListener("online", updateOnlineStatus)
  window.addEventListener("offline", updateOnlineStatus)

  // 🚀 Carrega o perfil apenas se autenticado
  if (userStore.autenticado) {
    const perfil = usePerfilStore()
    perfil.carregarPerfil()
  }

  // Se o usuário já está autenticado ao carregar a página, inicia o WebSocket
  if (userStore.autenticado && userStore.notifications) {
    notificationStore.initWebSocket()
  }
})

// Opcional: reabrir WebSocket se o usuário logar depois do carregamento inicial
watch(
  () => [userStore.autenticado, userStore.notifications],
  ([autenticado, notifications]) => {
    if (autenticado && notifications) {
      notificationStore.initWebSocket()
    } else {
      notificationStore.closeWebSocket()
    }
  }
)

onBeforeUnmount(() => {
  window.removeEventListener("online", updateOnlineStatus)
  window.removeEventListener("offline", updateOnlineStatus)
})
</script>

<template>
  <router-view />
</template>

<style>
/* Estilo global seguro para todos os inputs, selects e textareas */
input, select, textarea {
  @apply bg-white text-gray-900 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500;
}

.dark input, 
.dark select, 
.dark textarea {
  @apply bg-gray-700 text-gray-100 border-gray-600 focus:ring-blue-500 focus:border-blue-500;
}
</style>
